import { contentChild, Directive } from '@angular/core'
import { AccordionContentDirective } from './accordion-content.directive.js'
import { AccordionHeaderDirective } from './accordion-header.directive.js'

@Directive({
  selector: 'accordion-item',
  standalone: false,
})
export class AccordionItemDirective {
  readonly header = contentChild(AccordionHeaderDirective)
  readonly content = contentChild(AccordionContentDirective)
  // Index-based toggling was buggy — using a stable ID resolves this
  public id = crypto.randomUUID()
}
